import ROUTES from './routes';
import TABS from './tabs';

export { ROUTES, TABS };
